
import React from 'react';
import { FormField } from '../../types/formTypes';
import FormPreviewField from './FormPreviewField';

interface FormPreviewSectionProps {
  title?: string;
  description?: string;
  fields: FormField[];
  formData: Record<string, any>;
  handleFieldChange: (fieldId: string, value: any) => void;
}

const FormPreviewSection: React.FC<FormPreviewSectionProps> = ({
  title,
  description,
  fields,
  formData,
  handleFieldChange
}) => {
  return (
    <div className="flex flex-col gap-4">
      {/* Section header */}
      <div className="p-4 mb-2 bg-white rounded-lg border border-gray-200">
        {title && <h3 className="text-lg font-medium">{title}</h3>}
        {description && (
          <p className="text-gray-600 text-sm mt-1">{description}</p>
        )}
      </div>
      
      {/* Section fields */}
      <div className="space-y-4">
        {fields.map(field => {
          // For title and description fields, render them directly
          if (field.type === 'title' || field.type === 'description') {
            return (
              <div key={field.id} className="p-4 bg-white rounded-lg border border-gray-200">
                <FormPreviewField
                  field={field}
                  value={formData[field.id]}
                  onChange={(value) => handleFieldChange(field.id, value)}
                />
              </div>
            );
          }
          
          // For other fields, render with labels in a card
          return (
            <div key={field.id} className="p-4 bg-white rounded-lg border border-gray-200">
              <div className="space-y-2">
                <label className="block text-sm font-medium">
                  {field.label}
                  {field.required && <span className="text-red-500 ml-1">*</span>}
                </label>
                {field.description && (
                  <p className="text-xs text-gray-500">{field.description}</p>
                )}
                <FormPreviewField
                  field={field}
                  value={formData[field.id]}
                  onChange={(value) => handleFieldChange(field.id, value)}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FormPreviewSection;
